export default __webpack_public_path__ + "static/timeline-01-c53233b4c1b339fc9b4deba5179c0f72.svg";